// Function submitSettings handles the submission
export const submitSettings = (event) => {
    event.preventDefault();
    // Check if selected repository name is valid
    if (
      localStorage.getItem("repoName") !== "Select" &&
      localStorage.getItem("repoName") !== ""
    ) {
      // construct Amazon S3 link based on company and repository name
      localStorage.setItem(
        "s3Link",
        localStorage.getItem("company") +
          "/Repositories/" +
          localStorage.getItem("repoName")
      );
    }
  };

